import React, { useContext } from "react";
import { IAllForColumnX, IGalleryList, IOneGallery } from "./Common";
import ColumnWaterfall from "./ColumnWaterfall";
import ImageUtil from "../../utils/image";
import { getWatermarks } from "../../utils/util";
import ReactSVG from "react-svg";
import { ThemeContext } from "../../store/ThemeProvider";
import useColumnWaterfallList from "./useColumnWaterfallList";
import { inject, observer } from "mobx-react";
import RootStore from '../../store/RootStore';

interface IAllForWaterfall extends IAllForColumnX {
  isHot?: boolean;
  lazy?: boolean;
  rootStore?: RootStore;
}

// 注意， 我的相片也是用的这个组件哦
const AllForWaterfall = function (props: IAllForWaterfall) {
  const { jigsaw } = props;
  const { column2, column1 } = useColumnWaterfallList(props.list);
  const { mainColor } = useContext(ThemeContext);

  const { galleryStore, wxuserStore } = props.rootStore!;
  const { currentPayedImages } = wxuserStore;

  return (
    <>
      {[column1, column2].map((column, index) => {
        return (
          <div
            className="rows"
            key={index}
            style={{
              borderRight: index === 0 ? `4px solid transparent` : "none",
            }}
          >
            {column.map((one, index) => {
              const {
                id,
                width,
                height,
                hash,
                originalIndex,
                galleryid,
                show_mark,
              } = one;

              const isVertical = +height > +width;
              // const styleName = isVertical
              //   ? 'wx_375_240_vertical'
              //   : 'wx_375_240';
              const styleName = "wx_375_240";

              return (
                <ColumnWaterfall
                  lazy={props.lazy}
                  isVertical={isVertical}
                  key={id}
                  id={id}
                  index={originalIndex}
                  jigsaw={jigsaw}
                  src={ImageUtil.style(
                    hash,
                    styleName,
                    {
                      width:Number(width),
                      height:Number(height),
                      targetWidth:375,
                      watermark: galleryStore.getWatermarksByKey(
                        String(galleryid),
                        show_mark
                      )
                    },
                    id
                  )}
                  width={width}
                  height={height}
                  onClick={() => props.onClick({ id, index, galleryid })}
                  isPayed={currentPayedImages[String(id)]}
                  afterChild={
                    props.isHot && originalIndex < 10 ? (
                      // 如果在付款状态下的话，错开一下位置，免得重叠
                      <div className="rank" style={{left:currentPayedImages[String(id)] ? 44 : 4}}>
                        <ReactSVG
                          src={require("../../svg/icon-rank.svg")}
                          className={"rank-icon"}
                          style={{ color: mainColor }}
                        />
                        <span className={"number"}>NO.{originalIndex + 1}</span>
                      </div>
                    ) : undefined
                  }
                />
              );
            })}
          </div>
        );
      })}
    </>
  );
};
export default inject("rootStore")(observer(AllForWaterfall));
